import React, { useState, useEffect } from 'react';
import { AWS_CONFIG } from '../config/aws';
import PanoramaSlider from './PanoramaSlider';

// 작업 갤러리 (파노라마 형태, 2026-05-26 개편 / 2026-06-08 클릭 확대 제거).
// 단일 자동 회전 슬라이더로 갤러리 이미지 순환. 클릭 확대(lightbox) 없음.
// 빈 상태(DDB 0개): 섹션 자체 숨김. 예시 placeholder 없음.

export default function Gallery() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch(`${AWS_CONFIG.apiUrl}/images?category=gallery`)
      .then(r => r.json())
      .then(data => {
        const items = (data.images || [])
          .filter(i => i.imageUrl)
          .map(i => ({ src: i.imageUrl, alt: i.alt || '작업 갤러리' }));
        setImages(items);
      })
      .catch(() => {});
  }, []);

  if (images.length === 0) return null;

  return (
    <section className="section" style={{ background: 'var(--surface)' }}>
      <div className="container">
        <h2 className="section-title">작업 갤러리</h2>
        <p className="section-subtitle">
          KOA DETAILING의 세차 결과물
        </p>

        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <PanoramaSlider images={images} aspectRatio="16 / 9" />
        </div>
      </div>
    </section>
  );
}
